import { useMutation } from '@tanstack/react-query';
import React, { useRef, useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { Nav } from './Nav';

export const BulkSearch = () => {
	// file inputs cannot be controlled, so just doing everything uncontrolled
	const fileInputRef = useRef<HTMLInputElement | null>(null);
	const localeInputRef = useRef<HTMLInputElement | null>(null);

	const [errorMessage, setErrorMessage] = useState<string | null>(null);

	const { authFetch } = useAuth({ scopes: [] });

	const { mutate, isError } = useMutation({
		mutationFn: async ({
			file,
			locales,
		}: {
			file: File;
			locales: string | undefined;
		}) => {
			const response = await authFetch(
				`/api/overrides/bulk-export?locales=${locales ? locales : ''}`,
				{
					method: 'POST',
					body: file,
				}
			);

			if (!response.ok) {
				throw new Error(
					`Bulk search failed with error: ${response.status} - ${response.statusText}`
				);
			}

			const blob = await response.blob();
			download(blob, file.name);
		},
		onError: (error: Error) => {
			if (error.message.includes('Unauthorized')) {
				setErrorMessage('Authentication failed, please log out and back in');
				return;
			}
			setErrorMessage(error.message);
			return;
		},
	});

	return (
		<>
			<Nav />
			<main>
				<p>Upload a .csv file with a single column of search terms. <a href="/static/example-search.csv" download>Download example</a></p>
				<p>
					Enter locales you want to have returned into the input, leave empty
					for all locales. use format like "en-GB,fr-FR"
				</p>
				<form
					className="search-toolbar"
					onSubmit={async (e) => {
						e.preventDefault();
						const file = fileInputRef.current?.files?.[0];
						const locales = localeInputRef.current?.value;
						if (!file || !file.name.endsWith('.csv')) {
							alert('Please provide a csv file');
							return;
						}
						mutate({ file, locales });

						// fileInputRef.current!.value = '';
						// localeInputRef.current!.value = '';
					}}
				>
					<input type="file" ref={fileInputRef} />
					<input
						className="bulk-locales"
						type="text"
						ref={localeInputRef}
						placeholder="locales"
					/>
					<button type="submit">Search</button>
					<br />
					{errorMessage && <p className="error">{errorMessage}</p>}
				</form>
			</main>
		</>
	);
};

function download(blob: Blob, filename: string) {
	const url = window.URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.style.display = 'none';
	a.href = url;
	// the filename you want
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	window.URL.revokeObjectURL(url);
}
